import React, { useState } from "react";
import {
  makeStyles,
  IconButton,
  Typography,
  Box,
  Hidden,
  MenuItem,
  Select,
  ListItem,
  ListItemText,
  SwipeableDrawer,
  List,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import AppBarUserIcon from "./AppBarUserIcon";
import CustomImage from "../../components/CustomImage";
import OpenVideoDialog from "./OpenVideoDialog";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    color: theme.palette.primary.main,
  },
  drawer: {
    background: theme.palette.background.default,
  },
  link: {
    cursor: "pointer",
    display: "inline",
    marginLeft: 35,
    marginRight: 35,
    textDecoration: "none",
  },
  flag: {
    marginLeft: 7,
    marginRight: 7,
    height: 15,
    objectFit: "scale-down",
  },
  languageSelector: {
    marginLeft: 20,
    marginRight: 20,
  },
}));

const languages = [
  {
    label: "English",
    value: "en",
    icon: `${process.env.PUBLIC_URL}/assets/icons/us.png`,
  },
  {
    label: "عربي",
    value: "ar",
    icon: `${process.env.PUBLIC_URL}/assets/icons/eg.png`,
  },
];

const links = [
  {
    title: "Projects",
    path: "/projects",
    requiresAuth: true,
  },
  {
    title: "Advertisements",
    path: "/advertisements",
    requiresAuth: true,
  },
  {
    title: "Interactive Video",
    path: "/interactive-video",
    requiresAuth: false,
  },
  {
    title: "Spinning Wheel",
    path: "/spinning-wheel",
    requiresAuth: false,
  },
];

export default function NavBarElements({ handleLogout }) {
  const classes = useStyles();

  const [language, setLanguage] = useState("en");
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);

  const [videoDialog, setVideoDialog] = React.useState(false);

  const isAuthenticated = useSelector((state) => state?.auth?.isLoggedIn);

  const handleLanguageChange = (event) => {
    setLanguage(event.target.value);
    if (isDrawerOpen) {
      setIsDrawerOpen(false);
    }
  };

  const toggleDrawer = (value) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsDrawerOpen(value);
  };

  const openInteractiveVideoDialog = () => {
    setVideoDialog(true);
  };

  const linksList = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {links.map((link, index) => {
          const path = link.path == "/interactive-video" ? null : link.path;
          return (
            <React.Fragment key={index}>
              {!link.requiresAuth || isAuthenticated ? (
                <ListItem
                  button
                  component={path == null ? null : Link}
                  to={path}
                  onClick={() => {
                    setIsDrawerOpen(false);

                    if (path == null) {
                      openInteractiveVideoDialog();
                    }
                  }}
                >
                  <ListItemText primary={link.title} />
                </ListItem>
              ) : (
                <React.Fragment />
              )}
            </React.Fragment>
          );
        })}
      </List>
    </div>
  );

  const linkItem = (link) => {
    const path = link.path == "/interactive-video" ? null : link.path;

    const typo = (
      <Typography
        component="span"
        variant="body1"
        className="font-weight-medium"
        onClick={path == null ? openInteractiveVideoDialog : null}
      >
        {link.title}
      </Typography>
    );

    return (
      <React.Fragment>
        {path == null ? (
          <span className={classes.link}>{typo}</span>
        ) : (
          <Link to={path} className={classes.link}>
            {typo}
          </Link>
        )}
      </React.Fragment>
    );
  };

  const languageSelector = () => {
    return (
      <Select
        value={language}
        onChange={handleLanguageChange}
        disableUnderline
        className={classes.languageSelector}
      >
        {languages.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Typography component="span" variant="body2">
              {option.label}
            </Typography>
            <CustomImage
              alt={option.label}
              src={option.icon}
              className={classes.flag}
            />
          </MenuItem>
        ))}
      </Select>
    );
  };

  return (
    <React.Fragment>
      {/* Web View */}
      <Hidden mdDown>
        <Box>
          {links.map((link, index) => (
            <React.Fragment key={index}>
              {!link.requiresAuth || isAuthenticated ? (
                linkItem(link)
              ) : (
                <React.Fragment />
              )}
            </React.Fragment>
          ))}
        </Box>
        <Box className="d-flex">
          {languageSelector()}{" "}
          {isAuthenticated && <AppBarUserIcon handleLogout={handleLogout} />}
        </Box>
      </Hidden>

      {/* Mobile View */}
      <Hidden lgUp>
        <IconButton
          edge="end"
          color="primary"
          aria-label="menu"
          onClick={toggleDrawer(true)}
        >
          <MenuIcon className={classes.menuButton} />
        </IconButton>

        <SwipeableDrawer
          anchor="right"
          open={isDrawerOpen}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          classes={{ paper: classes.drawer }}
        >
          {linksList()}

          <List>
            <ListItem>
              {isAuthenticated && (
                <AppBarUserIcon handleLogout={handleLogout} />
              )}
            </ListItem>
            <ListItem>{languageSelector()}</ListItem>
          </List>
        </SwipeableDrawer>
      </Hidden>
      <OpenVideoDialog open={videoDialog} setOpen={setVideoDialog} />
    </React.Fragment>
  );
}
